export enum ActivitiesRoutesEnum {
    ACTIVITY_PREFIX = 'activities',
    ACTIVITY_LIST   = 'activities_list',
    ACTIVITY_DETAIL = 'activities_detail',
    ACTIVITY_KPI    = 'activities_kpi',
    ACTIVITY_SHIFTS = 'activities_shifts',
    ACTIVITY_TICKETS = 'activities_tickets'
}
